import { gql } from '@apollo/client'

export default gql`
  fragment contractLayout on CarServicePlan {
    id
    contractHeaderFullUri
    contractFooterFullUri
  }
`
